import { HubConnectionState } from '@microsoft/signalr';
import { SignalRHubType } from '@mti/multitenant-ui-shared';
import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import {
  AdditionalHubConnectionState,
  ContainerState,
  HubStatusesType,
} from './types';

export const DEFAULT_HUB_STATUS = {
  hubType: SignalRHubType.None,
  status: AdditionalHubConnectionState.Uninitialised,
  disconnectCount: 0,
};

// The initial state of the Header container
export const initialState: ContainerState = {
  signalRHubStatuses: {
    [SignalRHubType.None]: DEFAULT_HUB_STATUS,
    [SignalRHubType.Booking]: {
      ...DEFAULT_HUB_STATUS,
      hubType: SignalRHubType.Booking,
    },
    [SignalRHubType.Query]: {
      ...DEFAULT_HUB_STATUS,
      hubType: SignalRHubType.Query,
    },
    [SignalRHubType.Config]: {
      ...DEFAULT_HUB_STATUS,
      hubType: SignalRHubType.Config,
    },
    [SignalRHubType.Vehicle]: {
      ...DEFAULT_HUB_STATUS,
      hubType: SignalRHubType.Vehicle,
    },
    [SignalRHubType.Messaging]: {
      ...DEFAULT_HUB_STATUS,
      hubType: SignalRHubType.Messaging,
    },
  },
};

const headerSlice = createSlice({
  name: 'headerState',
  initialState,
  reducers: {
    updateHubStatus(
      state,
      action: PayloadAction<{
        hubStatuses: HubStatusesType;
      }>,
    ) {
      state.signalRHubStatuses = action.payload.hubStatuses;
    },
    updateSingleHubStatus(
      state,
      action: PayloadAction<{
        hubType: SignalRHubType;
        updatedHubStatus: HubConnectionState | AdditionalHubConnectionState;
      }>,
    ) {
      const { updatedHubStatus, hubType } = action.payload;
      if (state.signalRHubStatuses[hubType].status === updatedHubStatus) return;
      const updatedHubState = {
        ...state.signalRHubStatuses[hubType],
        status: updatedHubStatus,
      };
      // We monitor if the hub has disconnected previously so we can avoid showing connected alerts on first connection
      if (updatedHubStatus === HubConnectionState.Disconnected)
        updatedHubState.disconnectCount++;

      state.signalRHubStatuses[action.payload.hubType] = updatedHubState;
    },
  },
});

export const { actions, reducer, name: sliceKey } = headerSlice;
